import React from "react";
import {Col} from "reactstrap";
import ReactPaginate from "react-paginate";
import {ArrowBackIos, ArrowForwardIos} from "@mui/icons-material";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(() => ({
    arrow: {
        fontSize: '1em',
        width: '1em',
        height: '1em',
    }
}))

const Pagination = ({
                        length,
                        pageSize,
                        onPageChange: onPageChangeProps,
                        initialPage = null,
                        currentPage = 0,
                        newVersion = false,
                    }) => {
    const classes = useStyles();

    /**
     * Calls the onPageChange Callback function with the newly selected page
     * If the selected is null does nothing (the first render under componentDidMount)
     * @param e
     */
    const onPageChange = (e) => {
        if (e.selected === null) return;
        if ((e.selected + 1) === currentPage) return;
        if (onPageChangeProps) onPageChangeProps(newVersion ? (e.selected + 1) : e);
    }

    return (
        <ReactPaginate
            initialPage={initialPage}
            forcePage={currentPage - 1}
            previousLabel={<ArrowBackIos className={classes.arrow}/>}
            nextLabel={<ArrowForwardIos className={classes.arrow}/>}
            breakLabel={<Col className='h-100 align-items-center justify-content-center no-padding'><p
                className='text-xl'>...</p></Col>}
            breakClassName={'break-point'}
            pageCount={Math.ceil(length / pageSize)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            onPageChange={onPageChange}
            containerClassName={`pagination ${length <= pageSize ? 'd-none' : ''}`}
            pageClassName='page-item'
            pageLinkClassName='page-link'
            previousClassName='prev'
            previousLinkClassName='page-link'
            nextClassName='next'
            nextLinkClassName='page-link'
            activeClassName='active'
        />
    );
};

export default Pagination;
